import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import CallToAction from 'src/Components/CallToAction';
import Container from 'src/Components/ContentContainer';
import SEO from 'src/Components/SEO';
import Layout from 'src/Layout';
import * as Base from 'src/page-styles/base.styled';
import * as Hero from 'src/page-styles/hero.styled';
import * as CustomButton from 'src/page-styles/button.styled';

import styled from 'styled-components';

const Columns = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;

  @media only screen and (min-width: 800px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const CustomHeroText = styled(Hero.Text)`
  box-sizing: border-box;

  padding-right: 0px;
  position: relative;

  @media only screen and (min-width: 1024px) {
    padding-right: 352px;
  }

  @media only screen and (min-width: 1200px) {
    padding-right: 512px;
  }
`;

function RSOC(): JSX.Element {
  return (
    <>
      <SEO
        title="Responsive Space Operations Center | Saber Astronautics"
        description="Responsive Space Operations Centers (RSOC) is Saber's next-generation Mission Control Center program with sites in Australia and the US"
        url="https://www.saberastro.com/space-cockpit"
      />
      <Layout>
        <Hero.Wrapper>
          <Hero.Cover />
          <StaticImage
            className="hero-image"
            src="../images/rsoc/rsoc_hero.png"
            alt="hero"
          />
          <CustomHeroText>
            <Hero.MajorHeader style={{ textAlign: 'left' }}>
              Responsive Space Operations Center
            </Hero.MajorHeader>
            <Hero.Header style={{ textAlign: 'left', marginBottom: '1rem' }}>
              <Base.Yellow>
                The next-generation Mission Control Centers operated by Saber,
                with locations in USA and Australia for follow the sun
                operations.
              </Base.Yellow>
            </Hero.Header>
            <Hero.Header style={{ textAlign: 'left' }}>
              <Link to="/contact-us">
                <CustomButton.Yellow fill>Get in touch</CustomButton.Yellow>
              </Link>
            </Hero.Header>
          </CustomHeroText>
        </Hero.Wrapper>
        <Container.Dark>
          <Base.Gap />
          <Base.Text>
            <Base.Header style={{ textAlign: 'center' }}>
              Ensure your safety of flight with Saber Astronautics' mission
              operations and integrated space traffic management services
            </Base.Header>
          </Base.Text>
          <Base.Gap />
          <Columns>
            <StaticImage
              className="rsoc-us"
              src="../images/rsoc_aus_1.jpg"
              alt="USA RSOC"
            />
            <StaticImage
              className="rsoc-aus"
              src="../images/rsoc_aus_2.jpg"
              alt="Australian RSOC"
            />
          </Columns>
          <Base.Gap />
          <Base.Gap />
          <Base.Text>
            <Base.Paragraph>
              Saber’s highly trained RSOC operators fly 24/7 from the United
              States and Australia, with experience in both small satellites as
              well as large multi-ton flights.
            </Base.Paragraph>
          </Base.Text>
          <Base.Gap />
          <Base.Paragraph style={{ textAlign: 'center' }}>
            The RSOC is a global leader in Space Domain Awareness, supporting
            the best in class of safety support into every shift to keep your
            constellation safe. The RSOC Marketplace has hundreds of dishes and
            similar number of telescopes and radars from channel partners
            worldwide to support your mission.
          </Base.Paragraph>
          <Base.Heading
            style={{
              background: `linear-gradient(180deg,#fec60a,#f18f01 90%)`,
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'rgba(0,0,0,0.2)',
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            Take the stress out of your mission.
          </Base.Heading>
        </Container.Dark>
        <CallToAction
          header="Interested in RSOC support?"
          linkText="Contact us"
          to="/contact-us/"
        />
      </Layout>
    </>
  );
}

export default RSOC;
